import { useGetPersonAppointmentsV1Query } from '../api/appointment.api'

export const useGetPersonAppointments = (personId: string) => {
  const {
    data: appointments = [],
    isLoading,
    isSuccess,
    error,
  } = useGetPersonAppointmentsV1Query(personId)

  return {
    appointments,
    isLoading,
    isSuccess,
    error,
  }
}
